<template>
    <div class="body">
        <v-header title="考核信息"></v-header>    
        <div class="conH"></div>
        <div class="main">
            <div class="main2">
                <div class="header">
                    <label>{{currMonth}}月考核</label>
                    <div class="picker">
                        <el-date-picker
                            :clearable='false'
                            type="month"
                            :editable="false"
                            size="mini"
                            value-format="yyyy-MM"
                            v-model="month"
                            :picker-options="pickerOptions0"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <div v-if="showMsg" class="tipMsg">该月没有查询到考核数据</div>
                <div v-if="showContent" class="hkContent">
                    <div class="item left">
                        <div class="item-title">
                            维持
                        </div>

                        <div  class="assess" v-for="(value,key,index) in keep" :key="key">

                            <div class="title">
                                <span class="left">{{key}}</span>
                            </div>
                            <div class="left assess_length">
                                <div class="parent">
                                    <span class="standard left" :style="{width:slength[index]}"></span>
                                </div>
                                <div class="parent">
                                    <span class="real left" :style="{width:rlength[index]}"></span>
                                </div>
                                <div class="complete" :style="{width:rlength[index]}">
                                    <span class="right" >达成{{value.real}}</span>
                                </div>
                            </div>
                            <div class="left label_name">
                                <span >标准值{{value.standard}}</span>
                                <span v-show="value.difference <= 0">差距{{value.difference}}</span>
                                <span v-show="value.difference > 0">超过{{value.difference}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="item right">
                        <div class="item-title">
                            晋升
                        </div>

                        <div class="assess" v-for="(value,key,index) in promote" :key="key">

                            <div class="title">
                                <span class="left">{{key}}</span>
                            </div>
                            <div class="left assess_length">
                                <div class="parent">
                                    <span class="standard-r left" :style="{width:sslength[index]}"></span>
                                </div>
                                <div class="parent">
                                    <span class="real-r left" :style="{width:rrlength[index]}"></span>
                                </div>
                                <div class="complete" :style="{width:rrlength[index]}">
                                    <span class="right" >达成{{value.real}}</span>
                                </div>
                            </div>
                            <div class="left label_name">
                                <span >标准值{{value.standard}}</span>
                                <span v-show="value.difference <= 0">差距{{value.difference}}</span>
                                <span v-show="value.difference > 0">超过{{value.difference}}</span>
                            </div>
                        </div>

                        <!-- <div class="assess" v-for="(value,key,index) in promote" :key="key">
                            <div class="title">
                                <span class="left">{{key}}</span>
                                <span class="right">标准值{{value.standard}}</span>
                            </div>
                            <div class="parent-r">
                                <span class="standard-r left" :style="{width:sslength[index]}"></span>差距{{value.difference}}
                            </div>
                            <div class="parent-r">
                                <span class="real-r left" :style="{width:rrlength[index]}"></span>
                            </div>
                            <div class="title complete">
                                <span class="right">达成{{value.real}}</span>
                            </div>
                        </div> -->
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
import vHeader from '@/layout/Header1.vue'
export default {
  components: {vHeader},
  data () {
    return {
      loading: true,
      req: {
        PID: '62001554',
        MONTH: '',
        SEARCHTYPE: 'P',
        SHEETFLAG: '',
        startIndex: '0',
        limit: '100',
        orderBy: ''
      },
      month: '',
      keep: '',
      currMonth: '',
      promote: '',
      slength: [],
      rlength: [],
      sslength: [],
      rrlength: [],
      showContent:true,
      showMsg:false,
      pickerOptions0: {
        disabledDate(time) {
          let now = new Date(); //当前日期
          let nowYear = now.getFullYear(); //当前年
          let lastMonthDate = new Date(); //上月日期
          lastMonthDate.setDate(1);
          //alert(lastMonthDate)
          lastMonthDate.setMonth(lastMonthDate.getMonth());
          let lastMonth = lastMonthDate.getMonth();
          if(lastMonth == 0) {
            nowYear = nowYear - 1
            lastMonth = 12
          }
          let lastMonthStartDate = new Date(nowYear, lastMonth, 1);
        //   console.log(lastMonthStartDate)
          return time.getTime() > lastMonthStartDate.getTime();
        }
      },
    }
  },
  watch: {
    month: function (newValue, oldValue) {
      this.req.MONTH = newValue.replace('-', '')
      if (newValue.split('-')[1] !== '10') {
        this.currMonth = newValue.split('-')[1].replace('0', '')
      } else {
        this.currMonth = newValue.split('-')[1]
      }

      this.getPersonalAssessmentInfo()
    }
  },
  methods: {
    change () {

    },
    // 查询数据
    getPersonalAssessmentInfo () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
        // target: document.querySelector('#getPolicyList')
      })
      let that = this
      api.post(url.getPersonalAssessmentInfo, this.req, function (res) {
        if(JSON.stringify(res.data.data) == "{}" || res.data.data == null || res.data.data == undefined){
            that.showMsg=true
            that.showContent=false
            loading.close();
        }else{
            that.showMsg=false
            that.showContent=true
            that.keep = res.data.data.keep
            that.promote = res.data.data.promote
            let keep = that.keep
            let promote = that.promote

            for (let key in keep) {
            if (Math.abs(keep[key].difference > 0)) {
                that.slength.push(((keep[key].standard * 100) / keep[key].real) + '%')
                that.rlength.push('100%')
            } else if (keep[key].difference < 0) {
                that.rlength.push(((keep[key].real * 100) / keep[key].standard) + '%')
                that.slength.push('100%')
            } else {
                that.rlength.push('100%')
                that.slength.push('100%')
            }
            }
            for (let key in promote) {
            if (promote[key].difference > 0) {
                that.sslength.push(((promote[key].standard * 100) / promote[key].real) + '%')
                that.rrlength.push('100%')
            } else if (promote[key].difference < 0) {
                that.rrlength.push(((promote[key].real * 100) / promote[key].standard) + '%')
                that.sslength.push('100%')
            } else {
                that.rrlength.push('100%')
                that.sslength.push('100%')
            }
            }
            loading.close();
        }        

        console.info(that.result)
        console.info(that.slength)
        console.info(that.rlength)
      })
    },
    format () {
      let year = this.month.getFullYear()
      let month = this.month.getMonth() + 1
      this.currMonth = month
      if (this.month.getMonth() < 10) {
        month = '0' + month
      }

      this.req.MONTH = year + '' + month
    },

  },

  activated (){
    this.month = new Date();
    this.format()
    this.getPersonalAssessmentInfo();
  }
}
</script>
<style>
</style>
<style scoped>
.body{
    width: 100%;
    min-height: 100%;
    /* background:#fff; */
}
.main{
    width: 100%;
    margin: 0 auto;
    
}
.main2{
    width: 90%;
    padding:30px;
    margin: 0 auto;
    margin-top:20px;
    background:#fff;
}
.header{
    width: 100%;
    height: 35px;
    /* padding-top: 20px; */
    padding-bottom: 10px;
}
label{
    color:#111111;
    font-size:20px;
    display: block;
    float: left;
}
.picker{
    color: #194793;
    width: 110px;
    float: right;
}
.el-input__inner{
    width: 100px;
    height: 20px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 120px;
    opacity: 1;
    cursor: pointer;
}
.el-input--mini .el-input__inner{
    height: 20px;
}
.el-input--mini .el-input__icon {
    color: #194793;
    line-height: 20px;
}
.el-input__prefix{
    left: 0;
}
.item{
    width: 48%;
    height: auto;
    padding-bottom: 30px;
    background: none;
}
.left{
    float: left;
}
.right{
    float: right;
}
.item-title{
    font-size:16px;
    color:rgba(17,17,17,1);
    line-height:50px;
}
.title{
    width: 100%;
    height: 20px;
    line-height: 20px;
    color:rgba(148,148,148,1);
    font-size:10px;
}
.assess{
    height: auto;
    font-size:10px;
    margin-bottom: 20px;
    overflow: hidden;
}
.assess_length{
    width: 75%;
}
.label_name{
    width: (25%-5px);
    padding-left: 5px;
}
.label_name span{
    display: block;
    height: 15px;
    line-height: 15px;
}
.label_name span:not(:first-child){
    color: #949494;
}
.standard, .standard-r{
    display: block;
    height: 15px;
    background:rgba(167,205,97,1);
}
.real, .real-r{
    display: block;
    background:rgba(239,114,46,1);
    height: 15px;
}
.real-r{
    background:rgba(237,62,81,1);
}
.standard-r{
    background:rgba(22,115,211,1);
}
.parent, .parent-r{
    height: 15px;
    line-height: 15px;
    color: #949494;
    font-size:10px;
}
.parent:nth-child(odd){
    border: 1px solid #A7CD61;
    border-bottom: none;
}
.parent:nth-child(even){
    border: 1px solid #EF722E;
    border-top: none;
}
.parent-r:nth-child(even){
    border: 1px solid #1673D3;
    border-bottom: none;
}
.parent-r:nth-child(odd){
    border: 1px solid #ED3E51;
    border-top: none;
}
.complete{
    color: #EF722E;
    min-width: 11%;
    height: 12px;
}
.tipMsg{ margin-top:20px;}
.hkContent{ height:auto; padding-bottom:20px; overflow: hidden;}
</style>



// WEBPACK FOOTER //
// src/pages/performance/personAssess.vue